import { ArrowDown, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

const cities = ["Avignon", "L'Isle-sur-la-Sorgue", "Vaison-la-Romaine"];

export default function HomeHero() {
  const navigate = useNavigate();
  const handleSearch = (event) => {
    event.preventDefault();
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(event.currentTarget).entries()) {
      if (value) params.set(key, value);
    }
    navigate(`/biens?${params.toString()}`);
  };

  return (
    <section className="hero-section">
      <div className="hero-backdrop" />
      <div className="hero-content container">
        <p className="hero-kicker" data-testid="hero-kicker">Vaucluse · immobilier autrement</p>
        <h1 data-testid="hero-title">La bonne place,<br /><span>au bon moment.</span></h1>
        <p className="hero-text" data-testid="hero-description">Ici, on gagne votre confiance avant votre mandat : écoute, transparence et honoraires fixes, à L’Isle-sur-la-Sorgue et dans tout le Vaucluse.</p>
        <a href="#selection" className="hero-scroll" data-testid="hero-scroll-link">Explorer <ArrowDown size={17} /></a>
      </div>
      <form className="search-panel" onSubmit={handleSearch} data-testid="home-property-search-form">
        <div className="search-field search-intent"><label htmlFor="hero-transaction">Je recherche</label><select id="hero-transaction" name="transaction" data-testid="hero-transaction-select" defaultValue="vente"><option value="vente">À acheter</option><option value="location">À louer</option></select></div>
        <div className="search-field"><label htmlFor="hero-city">Où ?</label><select id="hero-city" name="city" data-testid="hero-city-select" defaultValue=""><option value="">Tout le Vaucluse</option>{cities.map((city) => <option key={city} value={city}>{city}</option>)}</select></div>
        <div className="search-field"><label htmlFor="hero-rooms">Pièces</label><select id="hero-rooms" name="min_rooms" data-testid="hero-rooms-select" defaultValue=""><option value="">Indifférent</option><option value="2">2 pièces +</option><option value="3">3 pièces +</option><option value="4">4 pièces +</option></select></div>
        <div className="search-field"><label htmlFor="hero-min-price">Budget minimum</label><select id="hero-min-price" name="min_price" data-testid="hero-min-price-select" defaultValue="130000"><option value="130000">À partir de 130 000 €</option><option value="200000">À partir de 200 000 €</option><option value="300000">À partir de 300 000 €</option><option value="500000">À partir de 500 000 €</option></select></div>
        <button className="search-submit" type="submit" data-testid="hero-search-submit"><Search size={20} /><span>Voir les biens</span></button>
      </form>
    </section>
  );
}